import { inputRules } from "prosemirror-inputrules";
import { Extension } from "../../core/extension";
import { UrlInputRule } from "./inputrule";
import { linkifyPasteRule } from "./paste-rules";
import { UrlDialogPlugin } from "./plugins";
import { toggleUrlMark } from "./commands";
import { linkMarkSpec } from "./schema";
export class UrlExtension extends Extension {
    addMarks(marks) {
        return marks.append(linkMarkSpec());
    }
    addPlugins(schema, plugins, { portalContainer }) {
        return plugins.concat([
            inputRules({ rules: [UrlInputRule] }),
            UrlDialogPlugin(portalContainer),
            linkifyPasteRule(),
        ]);
    }
    addCommands(schema) {
        return {
            toggleUrlMark: toggleUrlMark(schema),
        };
    }
}
